var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosaicSnapshot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.79,
    height: 42.723,
    viewBox: "0 0 47.79 42.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3333",
    "data-name": "Group 3333",
    transform: "translate(-386.541 -18.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M421.677,51.1H398.445a3.651,3.651,0,0,1-3.647-3.646V32a3.651,3.651,0,0,1,3.647-3.646h6.268c.348-1.128.888-2.593,2.106-2.593h7.132c1.126,0,1.642,1.351,2.083,2.593h5.643A3.651,3.651,0,0,1,425.325,32V47.452a3.651,3.651,0,0,1-3.648,3.646M398.445,30.354A1.649,1.649,0,0,0,396.8,32V47.452a1.649,1.649,0,0,0,1.647,1.646h23.232a1.649,1.649,0,0,0,1.648-1.646V32a1.649,1.649,0,0,0-1.648-1.646h-6.316c-.739,0-.947-.586-1.167-1.206a10.966,10.966,0,0,0-.57-1.387h-6.536a7.5,7.5,0,0,0-.549,1.461c-.144.478-.341,1.132-1.108,1.132Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M410.06,47.209a7.483,7.483,0,1,1,7.485-7.484,7.491,7.491,0,0,1-7.485,7.484m0-12.966a5.483,5.483,0,1,0,5.485,5.482,5.488,5.488,0,0,0-5.485-5.482",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M428.649,60.917h-7.884a1,1,0,0,1,0-2h7.884a3.685,3.685,0,0,0,3.682-3.68V46.815a1,1,0,0,1,2,0v8.422a5.687,5.687,0,0,1-5.682,5.68",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M399.059,60.917H392.22a5.686,5.686,0,0,1-5.679-5.68V46.815a1,1,0,0,1,2,0v8.422a3.684,3.684,0,0,0,3.679,3.68h6.839a1,1,0,0,1,0,2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M387.542,31.722a1,1,0,0,1-1-1V23.874a5.685,5.685,0,0,1,5.678-5.68h6.84a1,1,0,0,1,0,2h-6.84a3.683,3.683,0,0,0-3.678,3.68v6.848a1,1,0,0,1-1,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M433.331,31.722a1,1,0,0,1-1-1V23.874a3.685,3.685,0,0,0-3.682-3.68h-7.883a1,1,0,0,1,0-2h7.883a5.687,5.687,0,0,1,5.682,5.68v6.848a1,1,0,0,1-1,1",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicSnapshot);
export default __webpack_public_path__ + "static/media/MosaicSnapshot.7b96da8a1025ac2f22a9008e4f627bb7.svg";
export { ForwardRef as ReactComponent };